import React from 'react';
import { CustomizedSwitchWrapper } from 'components/CustomizedSwitchWrapper/CustomizedSwitchWrapper';
import { ModuleRoute } from '../../taboola-common-frontend-modules/multi-layer-drawer/components/ModuleRoute/ModuleRoute';
import { path } from '../constants';
import { ThirdPartyConnectContent } from './ThirdPartyConnectContent';

export const ThirdPartyConnect = () => {
    return (
        <CustomizedSwitchWrapper>
            <ModuleRoute path={path} render={props => <ThirdPartyConnectContent {...props} />} />
        </CustomizedSwitchWrapper>
    );
};
